import Administrative from '@/modules/Administrative/pages/TagNfcPage.vue';
import AdministrativePage from '@/modules/Administrative/pages/TagNfcPage.vue';
import Outils from '@/modules/Outils/pages/OutilsPage.vue';
import Contact from '@/modules/Contact/pages/ContactPage.vue';
import DemandeDevisSinglePage from '@/modules/DemandeDevis/pages/DemandeDevisSinglePage.vue';
import ListDemandeDevisPage from '@/modules/DemandeDevis/pages/ListDemandeDevisPage.vue';
import InterventionRequestSinglePage from '@/modules/DemandeIntervention/pages/DemandeInterventionSinglePage.vue';
import ListDemandeInterventionPage from '@/modules/DemandeIntervention/pages/ListDemandeInterventionPage.vue';
import DevisDetailPage from '@/modules/Devis/pages/DevisDetailPage.vue';
import ListDevisPage from '@/modules/Devis/pages/ListDevisPage.vue';
import Estimate from '@/modules/Estimate/pages/EstimatePage.vue';
import Home from '@/modules/Home/pages/HomePage.vue';
import Intervention from '@/modules/Intervention/pages/InterventionPage.vue';
import Login from '@/modules/Login/pages/Login.vue';
import SuiviPreventif from '@/modules/Preventif/pages/SuiviPreventif.vue';
import ReclamationPage from '@/modules/Reclamation/pages/ReclamationPage.vue';
import ListFacturesPage from '@/modules/SuiviFactures/pages/ListFacturesPage.vue';
import ListFacturesEnRetard from '@/modules/SuiviFactures/components/ListFacturesEnRetard.vue';
import ListFacturesAvantEcheance from '@/modules/SuiviFactures/components/ListFacturesAvantEcheance.vue';
import InterventionDetailPage from '@/modules/SuiviInterventions/pages/InterventionDetailPage.vue';
import ListInterventionPage from '@/modules/SuiviInterventions/pages/ListInterventionPage.vue';
import SuiviReclamationPage from '@/modules/SuiviReclamation/pages/SuiviReclamationPage.vue';
import CguPage from '@/modules/CGU/pages/CguPage.vue';
import PolitiqueConfidentialitePage from '@/modules/PolitiqueConfidentialite/pages/PolitiqueConfidentialitePage.vue';
import i18n from '@/plugins/i18n';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import DocumentReglementairePage from '@/modules/DocumentReglementaire/pages/DocumentReglementairePage.vue';
import { store } from '@/plugins/store';
import { DOCUMENT_REGLEMENTAIRE } from '@/modules/DocumentReglementaire/store/mutation-types';
import MyAccount from '@/modules/Account/pages/MyAccount.vue';
import ListInterventionPreventivePage
    from '@/modules/SuiviInterventionsPreventives/pages/ListInterventionPreventivePage.vue';
import InterventionPreventiveDetailPage
    from '@/modules/SuiviInterventionsPreventives/pages/InterventionPreventiveDetailPage.vue';
import { SITE_LIST } from '@/modules/SiteList/store/mutation-types';
import RechercheEquipement from '@/modules/RechercheEquipement/pages/RechercheEquipement.vue';
import SuiviFinancier from '@/modules/SuiviFactures/components/SuiviFinancier.vue';
import RapportASigner from '@/modules/RapportASigner/pages/RapportASigner.vue';
import Rapport from '@/modules/Rapport/pages/Rapport.vue';
import { registerGuard } from '@/router/Guards';
import NoteReclamation from '@/modules/NoteReclamation/pages/NoteReclamation.vue';
import ValidationDevisPage from '@/modules/DevisValidation/pages/ValidationDevisPage.vue';
import ListFacturesPayees from '@/modules/SuiviFactures/components/ListFacturesPayees.vue';
import Satisfaction from '@/modules/Satisfaction/Satisfaction.vue';
import QuestionPage from '@/modules/Satisfaction/pages/QuestionPage.vue';
import DashboardFournisseur from '@/modules/DashboardFournisseur/pages/DashboardFournisseur.vue';
import ChoixPortailFournisseur from '@/modules/ChoixPortail/pages/ChoixPortailFournisseur.vue';
import ChoixPortailClient from '@/modules/ChoixPortail/pages/ChoixPortailClient.vue';
import FacturesFournisseur from '@/modules/FacturesFournisseurs/pages/FacturesFournisseurList.vue';
import FactureFournisseurPage from '@/modules/FacturesFournisseurs/pages/FactureFournisseurPage.vue';
import ReglementFournisseurPage from '@/modules/ReglementsFournisseurs/pages/ReglementFournisseurPage.vue';
import ReglementFournisseurList from '@/modules/ReglementsFournisseurs/pages/ReglementFournisseurList.vue';
import { Permissions } from '@/router/AccessControl';
import EditionDashboard from '@/modules/Home/pages/EditionDashboard.vue';
import DOE from '@/modules/DOE/pages/DOE.vue';
import Equipements from '@/modules/Equipements/pages/Equipements.vue';

export const routesHeader: Array<RouteRecordRaw> = [
    {
        path: '/dashboard',
        component: Home,
        meta: {
            hasDropdown: false,
            droit: '',
            requiresAuth: true,
        },
        beforeEnter: (): Promise<boolean> => {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/edition-dashboard',
        component: EditionDashboard,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter: (): Promise<boolean> => {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/intervention',
        name: i18n.global.t('app.intervention'),
        component: Intervention,
        meta: {
            hasDropdown: true,
            droit: '',
            requiresAuth: true,
        },
        beforeEnter: (): Promise<boolean> => {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/devis',
        name: i18n.global.t('app.estimate'),
        component: Estimate,
        meta: {
            hasDropdown: true,
            droit: '',
            requiresAuth: true,
        },
        beforeEnter: (): Promise<boolean> => {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/facturation',
        name: 'Facturation',
        component: ListFacturesPage,
        children: [
            { path: '', component: ListFacturesEnRetard },
            { path: 'echeance', component: ListFacturesAvantEcheance },
            { path: 'payee', component: ListFacturesPayees },
            { path: 'suivi', component: SuiviFinancier },
        ],
        meta: {
            hasDropdown: false,
            droit: 'consulter.facture.recue',
            requiresAuth: true,
        },
        beforeEnter: (): Promise<boolean> => {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/administratif',
        name: i18n.global.t('app.administrative'),
        component: Administrative,
        meta: {
            hasDropdown: true,
            droit: '',
            requiresAuth: true,
        },
        beforeEnter: (): Promise<boolean> => {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/outils',
        name: i18n.global.t('app.energy.monitoring'),
        component: Outils,
        meta: {
            hasDropdown: true,
            droit: '',
            requiresAuth: true,
        },
        beforeEnter: (): Promise<boolean> => {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/satisfaction',
        name: 'Satisfaction',
        meta: { hasDropdown: false, droit: '', requiresAuth: true },
        component: Satisfaction,
        beforeEnter: (): Promise<boolean> => {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/reclamation',
        name: i18n.global.t('reclamation.navigation.title'),
        component: ReclamationPage,
        beforeEnter: (): Promise<boolean> => {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
        meta: {
            hasDropdown: true,
            droit: '',
            requiresAuth: true,
        },
    },
    {
        path: '/contacts',
        name: i18n.global.t('app.contacts'),
        component: Contact,
        meta: {
            hasDropdown: false,
            droit: '',
            requiresAuth: true,
        },
        beforeEnter: (): Promise<boolean> => {
            store.commit(`siteList/${SITE_LIST.RESET}`);
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
];

const subRoutes: Array<RouteRecordRaw> = [
    {
        path: '/monCompte',
        name: i18n.global.t('app.myAccount'),
        component: MyAccount,
        meta: {
            droit: '',
            requiresAuth: true,
        },
    },
    {
        path: '/suivi-demande-intervention',
        name: i18n.global.t('app.list.intervention'),
        component: ListDemandeInterventionPage,
        meta: {
            droit: 'consulter.demande',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/suivi-demande-intervention/:id',
        name: 'interventionRequestDetailView',
        component: InterventionRequestSinglePage,
        meta: {
            droit: 'consulter.demande',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/suivi-travaux/:id',
        name: 'interventionDetailView',
        component: InterventionDetailPage,
        meta: {
            droit: 'consulter.interventionNP',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/suivi-travaux',
        name: 'interventionNonPreventive',
        component: ListInterventionPage,
        meta: {
            droit: 'consulter.interventionNP',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/suivi-interventions-preventives',
        name: 'interventionPreventive',
        component: ListInterventionPreventivePage,
        meta: {
            droit: 'consulter.interventionP',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/suivi-interventions-preventives/:id',
        name: 'interventionPreventiveDetailView',
        component: InterventionPreventiveDetailPage,
        meta: {
            droit: 'consulter.interventionP',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/rapports-a-signer',
        name: 'rapportASigner',
        component: RapportASigner,
        meta: {
            droit: 'consulter.interventionNP',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/suivi-demandes-devis',
        name: 'listDemandeDevisPage',
        component: ListDemandeDevisPage,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/suivi-demandes-devis/:id',
        name: 'devisRequestDetailView',
        component: DemandeDevisSinglePage,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/suivi-devis',
        name: 'listDevisPage',
        component: ListDevisPage,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/suivi-devis/:id',
        name: 'detailDevisPage',
        component: DevisDetailPage,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/suivi-reclamation',
        name: 'suiviReclamation',
        component: SuiviReclamationPage,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/documents',
        name: 'documentReglementaire',
        component: DocumentReglementairePage,
        beforeEnter: () => {
            store.commit(`documentReglementaireState/${DOCUMENT_REGLEMENTAIRE.SET_FILTER_SITE}`, []);
            store.commit(`documentReglementaireState/${DOCUMENT_REGLEMENTAIRE.RESET_ITEMS}`);
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
        meta: {
            droit: '',
            requiresAuth: true,
        },
    },
    {
        path: '/tag-nfc',
        name: 'tagNFC',
        component: AdministrativePage,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/equipements',
        name: 'rechercheEquipements',
        component: RechercheEquipement,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },

    {
        path: '/equipements/:id',
        name: 'equipements',
        component: Equipements,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },

    {
        path: '/suivi-preventif',
        name: 'suiviPreventif',
        component: SuiviPreventif,
        meta: {
            droit: 'consulter.interventionP',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/cgu',
        name: 'CGU',
        component: CguPage,
        meta: {
            droit: '',
            requiresAuth: false,
        },
    },
    {
        path: '/politique-confidentialite',
        name: 'PolitiqueConfidentialite',
        component: PolitiqueConfidentialitePage,
        meta: {
            droit: '',
            requiresAuth: false,
        },
    },
    {
        path: '/rapports',
        name: 'rapports',
        component: Rapport,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/doe',
        name: 'doe',
        component: DOE,
        meta: {
            droit: '',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
    {
        path: '/question/:note/:step',
        name: 'QuestionPage',
        component: QuestionPage,
        props: route => ({
            note: Number(route.params.note),
            step: Number(route.params.step),
        }),
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
];

const loginRoutes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: to => {
            if (to.hash && to.hash.startsWith('#/')) {
                return to.hash.substring(1);
            }
            return '/login';
        },
        meta: {
            droit: '',
            requiresAuth: false,
        },
    },
    {
        path: '/login',
        name: i18n.global.t('app.login'),
        component: Login,
        meta: {
            droit: '',
            requiresAuth: false,
        },
        beforeEnter(to) {
            if (to.hash && to.hash.startsWith('#/')) {
                return to.hash.substring(1);
            }
            return true;
        },
    },
];

const otherRoutes: Array<RouteRecordRaw> = [
    {
        path: '/validation-devis',
        name: 'validationDevis',
        component: ValidationDevisPage,
        meta: {
            droit: '',
            requiresAuth: false,
        },
    },
    {
        path: '/reclamations/:reclamationId(\\d+)/note/:note(\\d+)/:jwt',
        name: 'note2',
        component: NoteReclamation,
        meta: {
            droit: '',
            requiresAuth: false,
        },
    },
    {
        path: '/noteReclamation',
        name: 'note',
        component: NoteReclamation,
        meta: {
            droit: '',
            requiresAuth: false,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.CLIENT);
        },
    },
];

const fournisseurRoutes: Array<RouteRecordRaw> = [
    {
        path: '/dashboard-fournisseur',
        component: DashboardFournisseur,
        name: 'DashboardFournisseur',
        meta: {
            droit: 'role.fournisseur',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.FOURNISSEUR);
        },
    },
    {
        path: '/choix-portail-fournisseur',
        component: ChoixPortailFournisseur,
        meta: {
            droit: 'role.fournisseur',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.FOURNISSEUR);
        },
    },
    {
        path: '/choix-portail-client',
        component: ChoixPortailClient,
        meta: {
            droit: 'role.fournisseur',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.FOURNISSEUR);
        },
    },
    {
        path: '/factures-fournisseur',
        component: FacturesFournisseur,
        meta: {
            droit: 'role.fournisseur',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.FOURNISSEUR);
        },
    },
    {
        path: '/factures-fournisseur/:id',
        name: 'factureFournisseurPage',
        component: FactureFournisseurPage,
        meta: {
            droit: 'role.fournisseur',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.FOURNISSEUR);
        },
    },
    {
        path: '/reglement-fournisseur/:id',
        name: 'reglementFournisseurPage',
        component: ReglementFournisseurPage,
        meta: {
            droit: 'role.fournisseur',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.FOURNISSEUR);
        },
    },
    {
        path: '/reglements-fournisseur',
        name: 'reglementFournisseurlist',
        component: ReglementFournisseurList,
        meta: {
            droit: 'role.fournisseur',
            requiresAuth: true,
        },
        beforeEnter() {
            return Permissions.userCanAccess(Permissions.FOURNISSEUR);
        },
    },
];

const routes: Array<RouteRecordRaw> = [
    ...routesHeader,
    ...subRoutes,
    ...loginRoutes,
    ...otherRoutes,
    ...fournisseurRoutes,
    {
        path: '/:pathMatch(.*)*',
        redirect: '/dashboard',
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

registerGuard(router);

export default router;
